import API from "@/shared/helpers/API";
import {useCartStore, useMenusStore} from "@/new-menu/stores";
import {useScriptStore} from "@/shared/stores";

function withCaptchaReady(cb) {
	const scriptStore = useScriptStore();
	if(scriptStore.loadedScripts.includes("captcha")) {
		cb();
	} else {
		scriptStore.loadScript("captcha", cb);
	}
}

export function initKioskStripe() {

	const menusStore = useMenusStore();
	const cartStore = useCartStore();

	if(!menusStore.business || !menusStore.business.business_id) return;
	if(!menusStore.paymentMethodsAvailable.includes('stripe')) return;
	if(typeof Android === "undefined" || typeof Android.setStripeCredentials !== "function") return;

	withCaptchaReady(() => {
		cartStore.execCaptcha((captchaSuccess, captchaToken) => {
			if(!captchaSuccess || !captchaToken) {
				console.warn("kiosk stripe init: captcha (location) failed");
				return;
			}

			API.init().checkoutTerminalLocation(menusStore.business.business_id, captchaToken, cartStore.captchaMode, (locRes) => {
				cartStore.resetAllCaptchaState();
				if(!locRes || locRes.result !== "OK" || !locRes.location_id) {
					console.warn("kiosk stripe init: terminal-location failed", locRes);
					return;
				}

				cartStore.execCaptcha((s2, t2) => {
					if(!s2 || !t2) {
						console.warn("kiosk stripe init: captcha (token) failed");
						return;
					}

					API.init().checkoutConnectionToken(menusStore.business.business_id, t2, cartStore.captchaMode, (tokRes) => {
						cartStore.resetAllCaptchaState();
						if(!tokRes || tokRes.result !== "OK" || !tokRes.token) {
							console.warn("kiosk stripe init: connection-token failed", tokRes);
							return;
						}

						try {
							Android.setStripeCredentials(tokRes.token, locRes.location_id);
						} catch(e) {
							console.warn("setStripeCredentials bridge call failed", e);
						}
					});
				});
			});
		});
	});
}

export function refreshKioskStripeConnectionToken() {
	const menusStore = useMenusStore();
	const cartStore = useCartStore();

	if(!menusStore.business || !menusStore.business.business_id) return;
	if(typeof Android === "undefined" || typeof Android.setStripeConnectionToken !== "function") return;

	withCaptchaReady(() => {
		cartStore.execCaptcha((success, captchaToken) => {
			if(!success || !captchaToken) return;
			API.init().checkoutConnectionToken(menusStore.business.business_id, captchaToken, cartStore.captchaMode, (tokRes) => {
				cartStore.resetAllCaptchaState();
				if(!tokRes || tokRes.result !== "OK" || !tokRes.token) return;
				try {
					Android.setStripeConnectionToken(tokRes.token);
				} catch(e) {
					console.warn("setStripeConnectionToken bridge call failed", e);
				}
			});
		});
	});
}
